export default __webpack_public_path__ + "dd24705858ef27ff36fb29748d89f8e6.png";